import React from 'react';
import { connect as connectFormik } from 'formik';
import { useSelector } from 'react-redux';
// components
import Table from 'shared/tables/Table';
import { AddButton } from 'shared/buttons';
import { FormikSelect } from 'shared/forms';
import FormikDatePicker from 'shared/forms/FormikDatePicker';
import Icon from 'shared/icons/IconComponent';
// store
import { getEndorsementTypes } from 'src/slices/driver/endorsementTypes';
import './styles.scss';

const LicenseEndorsementsGrid = ({ disabled, formik }) => {
  const endorsementTypes = useSelector((state) => getEndorsementTypes(state)
    .map(({ value, description }) => ({ value, label: description }))
  );

  const {
    values: { licenseEndorsements },
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = formik;

  const getEndorsementIndex = (endorsement) => licenseEndorsements.indexOf(endorsement);

  const getFieldName = (endorsement, field) => {
    const endorsementIndex = getEndorsementIndex(endorsement);
    return `licenseEndorsements[${endorsementIndex}].${field}`;
  };

  const setEndorsementFieldValue = (fieldName, value) => {
    setFieldValue(fieldName, value);
    setFieldTouched(fieldName);
  };

  const setEndorsementDeleted = (endorsement) => {
    const endorsementIndex = getEndorsementIndex(endorsement);
    const newLicenseEndorsements = licenseEndorsements.filter((_, i) => i !== endorsementIndex);
    setFieldValue('licenseEndorsements', newLicenseEndorsements);
  };

  const onAddEndorsement = () => {
    setFieldValue('licenseEndorsements', [...licenseEndorsements, { typeId: null, expirationDate: null }]);
  };

    return (
        <div
        style={{
        width: '100%',
        maxWidth: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <label>License Endorsements</label>
      <Table
        className='table--primary-color'
        data={licenseEndorsements}
        style={{ width: '100%' }}
        columns={[
          {
            Header: 'Endorsement Type',
            id: 'typeId',
            isCentered: false,
            Cell: ({ original }) => {
              const fieldName = getFieldName(original, 'typeId');
              return (
                <FormikSelect
                  disabled={disabled}
                  wrapperClass='select tableSelect'
                  options={endorsementTypes}
                  name={fieldName}
                  isTableSelect
                  overflowModal
                  value={original?.typeId}
                  onChange={(selected) => setEndorsementFieldValue(fieldName, selected?.value)}
                  onBlur={setFieldTouched}
                  touched={touched}
                  touchedNested={true}
                  errors={errors}
                />
              );
            },
            style: { overflow: 'visible', position: 'relative', display: 'flex', justifyContent: 'center' },
          },
          {
            Header: 'Expiration Date',
            id: 'expirationDate',
            width: 225,
            isCentered: false,
            Cell: ({ original }) => {
              const fieldName = getFieldName(original, 'expirationDate');
              return (
                <FormikDatePicker
                  disabled={disabled}
                  wrapperClass='wrapper-fill-column'
                  name={fieldName}
                  showBuiltInError={false}
                  value={original?.expirationDate}
                  onChange={(value) => setEndorsementFieldValue(fieldName, value)}
                  onBlur={setFieldTouched}
                  setTouched={() => setFieldTouched(fieldName, true)}
                  errors={errors}
                  touched={touched}
                />
              );
            },
          },
          {
            Header: 'Remove',
            id: 'remove',
            width: 125,
            isCentered: true,
            Cell: ({ original }) => (
              <span
                data-tip='Remove Endorsement'
                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                onClick={() => setEndorsementDeleted(original)}
              >
                <Icon icon='times' />
              </span>
            ),
          },
        ]}
      />
      <div className='toolbar toolbar--xxs'>
        <div className='toolbar--column form-toolbar-footer'>
          <AddButton title="Add Endorsement" onClick={onAddEndorsement} />
        </div>
      </div>
    </div>
  );
};

export default connectFormik(LicenseEndorsementsGrid);
